import React, { useRef } from "react";
import "../css/ListOfEnquiryOrderReturn.css";
import BackgroundImage from "./BackgroundImage";
import ic_calendar from "../img/ic_calendar.png";
import { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

function ListOfEnquiryOrderReturn(props) {
  const { listName } = props;
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());

  const calenderRef = useRef(null);
  const calenderTwoRef = useRef(null);

  return (
    <div>
      <div className="ListOfEnquiryOrderReturn-main-container">
        <h5 className="ms-0 my-4">List Of {listName}</h5>

        <div className="ListOfEnquiryOrderReturn-inner-container">
         

          <div className="d-flex flex-wrap">


            <div class="form-floating ">
              <input
                name="reference"
                type="text"
                class="form-control" id="floatingInput" placeholder="Reference" />
              <label for="floatingInput">Reference</label>
            </div>

            <div class="form-floating ">
              <input
                disabled={listName === "Order" ? "" : "disabled"}
                name="reference"
                type="text"
                class="form-control" id="OrderNumber" placeholder="Order Number" />
              <label for="OrderNumber">Order Number</label>
            </div>

            <div class="form-floating ">
              <input
                disabled={listName === "Enquiry" ? "" : "disabled"}
                name="reference"
                type="text"
                class="form-control" id="floatingInput" placeholder="Enquiry Number" />
              <label for="floatingInput">Enquiry Number</label>
            </div>


            <div className="ListOfEnquiryOrderReturn-radio-container ">

              {/* start of row  */}
              <div className="datePickerRow">

                <label htmlFor="date-range-radio-btn">
                  Date Range / Status
                </label>

                <label className="ListOfEnquiryOrderReturn-from-label">
                  From
                </label>

                <DatePicker
                  placeholderText="mm/dd/yyyy"
                  className="datePickerInputLibrary"
                  ref={calenderRef}
                  selected={startDate}
                  selectsStart
                  startDate={startDate}
                  endDate={endDate}
                  onChange={(date) => setStartDate(date)}
                />

                <img
                  src={ic_calendar}
                  className="ListOfEnquiryOrderReturn-dateInput-img"
                  onClick={() => {
                    calenderRef.current.setOpen(true);
                  }}
                  alt="start date"
                />

                <label className="ListOfEnquiryOrderReturn-from-label">To</label>

                <DatePicker
                  placeholderText="mm/dd/yyyy"
                  className="datePickerInputLibrary"
                  ref={calenderTwoRef}
                  selected={endDate}
                  selectsEnd
                  startDate={startDate}
                  endDate={endDate}
                  minDate={startDate}
                  onChange={(date) => setEndDate(date)}
                />

                <img
                  src={ic_calendar}
                  className="ListOfEnquiryOrderReturn-dateInput-img"
                  onClick={() => {
                    calenderTwoRef.current.setOpen(true);
                  }}
                  alt="end date"
                />
              </div>
              {/* end of row  */}
            </div>
          </div>

          <div className="d-flex flex-wrap align-items-center">

            <div className="ListOfEnquiryOrderReturn-select-container">
              <label>Status</label>
              <select name="status-selection">
                <option value="0">Select Status</option>
                <option value="1">All</option>
                <option value="2">Being Processed</option>
                <option value="3">Quote Received</option>
              </select>
            </div>

            <div className="ListOfEnquiryOrderReturn-my-order-container">
              <input
                type="checkbox"
                name="my-orders-only"
                id="my-orders-only-id"
              />
              <label htmlFor="my-orders-only-id">My Orders Only</label>
            </div>

            <button className="ListOfEnquiryOrderReturn-search-button">
              Search Orders
            </button>
          </div>

        </div>

        <BackgroundImage />
      </div>
    </div>
  );
}

export default ListOfEnquiryOrderReturn;
